<template>
  <div>
    <div v-if="status == 'EXECUTANDO' && progresso" class="d-inline-flex">
      <v-progress-circular indeterminate color="black" size="20" width="1" class="ml-0" />
      <div class="ml-2 size-status">{{ progresso }}</div>
    </div>

    <v-progress-circular v-else-if="status == 'EXECUTANDO'" indeterminate color="black" size="20" width="1" class="ml-3" />
    <span v-else-if="status == 'SUCESSO'" class="size-status" style="color: green">
      <v-icon small color="green" class="icon-status pb-1">mdi-check-bold</v-icon>
      Sucesso
    </span>
    <span v-else-if="status == 'FALHA'" class="size-status" style="color: red">
      <v-icon small color="red" class="icon-status pb-1">mdi-alert</v-icon>
      Falha
    </span>
    <span v-else-if="status == 'AGUARDANDO'" class="size-status" style="color: #3fa6f4">
      <v-icon small color="#3fa6f4" class="icon-status pb-1">mdi-clock-time-four-outline</v-icon>
      Aguardando
    </span>
    <span v-else-if="status == 'RASCUNHO'" class="size-status" style="color: #4b549a">
      <v-icon small color="#4b549a" class="icon-status pb-1">mdi-pencil-outline</v-icon>
      Rascunho
    </span>
    <span v-else-if="status == 'EM-ANALISE'" class="size-status" style="color: #a672ff">
      <v-icon small color="#a672ff" class="icon-status pb-1">mdi-timer-sand</v-icon>
      Em An&aacute;lise
    </span>
    <span v-else-if="status == 'EXPIRADO'" class="size-status" style="color: gray">
      <v-icon small color="gray" class="icon-status pb-1">mdi-timer-off-outline</v-icon>
      Expirado
    </span>
    <span v-else-if="status == 'FINALIZADO'" class="size-status" style="color: green">
      <v-icon small color="green" class="icon-status pb-1">mdi-check-bold</v-icon>
      Finalizado
    </span>
    <span v-else-if="status == 'CRIANDO'" class="size-status" style="color: #4b549a">
      <v-icon small color="#4b549a" class="icon-status pb-1">mdi-pencil</v-icon>
      Criando
    </span>
    <span v-else-if="status == 'DUPLICADO'" class="size-status" style="color: rgb(190, 156, 2)">
      <v-icon small color="#be9c02" class="icon-status pb-1">mdi-content-copy</v-icon>
      Duplicado
    </span>
    <span v-else class="size-status" style="color: gray">
      {{ treatedStatus }}
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      status: {
        type: String,
        required: true
      },

      progresso: {
        type: String,
        default: ''
      }
    },

    computed: {
      treatedStatus() {
        return this.status.charAt(0).toUpperCase() + this.status.slice(1).toLowerCase();
      }
    }
  };
</script>

<style>
  .size-status {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }

  .size-status .v-icon {
    font-size: 0.9rem !important;
  }

  .icon-status {
    margin-right: 1.7px !important;
  }
</style>